import { phases } from "@/mocks/eventArchive";

const toneMap: Record<string, string> = {
  strong: "text-primary-600 border-primary-200 bg-primary-100/70",
  mid: "text-secondary-800 border-secondary-200 bg-secondary-100/70",
  accent: "text-accent-800 border-accent-300 bg-accent-100",
  quiet: "text-foreground-700 border-background-300 bg-background-200",
};

export default function PhaseSection() {
  return (
    <section id="jieduan" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <span className="sec-kicker inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span>阶段拆解<span className="h-px w-8 bg-primary-400"></span>
          </span>
          <h2 className="font-head-cn mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            四段式始末：点燃 · 拉锯 · 翻转 · 冷却
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600">
            把几十个散落节点压缩成四段，每段记住「一个关键词 + 一个日期」，整件事的骨架就能立住。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {phases.map((p) => (
            <article
              key={p.no}
              className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100 p-6 md:p-7"
            >
              <span className="pointer-events-none absolute -right-3 -top-8 font-num text-[120px] leading-none text-foreground-950/5 select-none">
                {p.no}
              </span>

              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-3">
                    <span className="font-num text-2xl text-primary-500">{p.no}</span>
                    <h3 className="font-head-cn text-2xl font-bold text-foreground-950">{p.name}</h3>
                  </div>
                  <p className="sec-kicker mt-1 text-xs font-semibold text-foreground-500">{p.en}</p>
                </div>
                <span
                  className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold whitespace-nowrap ${toneMap[p.tone] || toneMap.quiet}`}
                >
                  {p.mark}
                </span>
              </div>

              <p className="mt-4 text-sm leading-7 text-foreground-700">{p.text}</p>

              <p className="mt-3 inline-flex items-center gap-2 text-xs font-medium text-foreground-500">
                <i className="ri-calendar-line"></i>{p.period}
              </p>

              <ul className="mt-5 space-y-2.5 border-t border-background-200 pt-5">
                {p.points.map((pt) => (
                  <li key={pt} className="flex items-start gap-2.5 text-sm text-foreground-800">
                    <span className="mt-1.5 flex h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500"></span>
                    {pt}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}